<template>
    <div class="auto">
      <div class="w22 fl">
        <div class="Menu000288"  v-for="(item,index) of menuList" :key="item.key" v-if="openKeys == item.key">
            <div class="menu">
                <div class="menuTitle">
                    <h1>
                      {{item.name}}
                    </h1>
                    <p>
                      {{item.text}}
                    </p>
                </div>
            </div>
            <div class="MenuList">
              <ul class="ul">
                <li :class="{'on':items.key == selectedKeys}"  v-for="(items,indexs) of item.children" :key="items.key"
                  @click="changeMenu(items,item)">
                  {{items.name}}
                </li>
              </ul>
            </div>
        </div>
      </div>
      <div class="w75 fr">
        <div class="Location002308">
          <div>
            {{selectMenu.name}}
          </div>
          <div>
              您所在位置:
              <a href="https://www.yzhospital.cn/">首页</a>
              <span @click="breadcrumbJump">{{selectMenu.father.name}}</span>
              <span>{{selectMenu.name}}</span>
          </div>
        </div>
        <div>
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive" />
        </div>
      </div> 
      <div class="clear"></div>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        openKeys: ['sub1'],
        selectedKeys:'user',
        rootSubmenuKeys:['sub1','sub2','sub3'],
        selectMenu:{
          father:{
            name:''
          }
        },
        menuList:[
            {
                name: '人力资源',
                text:'HUMANRESOURCES',//Party building
                key:"sub1",
                url:'/TalentRecruitment/list.aspx',
                children:[
                    {
                        name: '人才招聘',
                        key:"talentRecruitment",
                        url:'https://www.yzhospital.cn/col67/list'
                    },
                    {
                        path: '/applyFor',
                        name: '在线应聘',
                        key:"applyFor",
                        children:['/applyForDetails']
                        
                    },
                ]
            },
            {
                name: '问卷调查',
                text:'SATISFACTION SURVEY',//Satisfaction survey
                key:"sub2",
                path:'/satisfaction',
                children:[
                    {
                        name: '满意度调查',
                        key:"satisfaction",
                        path:'/satisfaction'
                    },
                ]
            },
            {
                name: '预约挂号',
                text:'APPOINTMENT REGISTRATION',//Appointment registration
                icon:'appstore',
                key:"sub3",
                path: '/appointment',
                children:[
                    {
                        path: '/appointment',
                        name: '我要挂号',
                        key:"appointment",
                    },
                    {
                        path: '/information',
                        name: '预约信息',
                        key:"information",
                        children:['/informationDetails']
                    },
                ]
            },
        ]
      };
    },
    mounted(){
      // console.log(window.location.pathname)
        for(let item of this.menuList){
          for(let items of item.children){
            if(items.path == window.location.pathname){
              this.selectedKeys = items.key
              this.openKeys = [item.key]
              this.selectMenu = items
              this.selectMenu.father = item
              break;
            }
            
            if(items.children && items.children.indexOf(window.location.pathname) != -1){
              this.selectedKeys = items.key
              this.openKeys = [item.key]
              this.selectMenu = items
              this.selectMenu.father = item
              break;
            }
          }
        }
    },
    watch: {
      $route(val) {
        //val即是this.$route
        //根据路由控制其他参数做不同处理
        for(let item of this.menuList){
          for(let items of item.children){
            if(items.path == val.path){
              this.selectedKeys = items.key
              this.openKeys = [item.key]
              this.selectMenu = items
              this.selectMenu.father = item
            }
          }
        }
      },
    },
    methods: {
      changeMenu(e,data){
        console.log(e)
        if(e.name == '人才招聘'){
           window.location= e.url
           return
        }
 
        if(e.url){
          window.location= 'https://www.yzhospital.cn'+ e.url
        }else{
          if(this.selectedKeys == e.key){

          }else{
            this.$router.push(e.path)
            this.selectedKeys = e.key
          }
          
        }
      },
      breadcrumbJump(){
        let e = this.selectMenu.father.children[0]
         if(e.name == '人才招聘'){
           window.location= e.url
           return
        }
        if(e.url){
          window.location = 'https://www.yzhospital.cn'+ e.url
        }else{
          if(e.path == window.location.pathname){

          }else{
            this.$router.push(e.path)
          // this.selectedKeys = e.key
          }
         
        }
      }
    },
  };
  </script>
  <style scoped lang="less">
    .auto{
      max-width: 1280px;
      margin: 0 auto;
      padding-top: 3%;
      padding-bottom: 4%;
      .w22 {
          width: 20%;
          padding-bottom: 4%;
      }
      .w75 {
        width: 76%;
        padding-bottom: 4%;
      }
      .fl{
        float: left;
      }
      .fr{
        float: right;
      }
    }
    .Menu000288 {
      background: #fff;
      // width: 20% ;
    
      .menu {
        width: 100%;
        height: 123px;
        background: url(https://www.yzhospital.cn/cn/images/Menu000288_tit.png) no-repeat center top;
      }
      .menuTitle {
        padding: 27px 0 0 30px;
        text-align: left;
        h1 {
            margin: 0;
            font-size: 25px;
            color: #FFF;
        }
        p {
            margin: 0;
            font-size: 16px;
            color: #86ada5;
            font-weight: bold;
            // text-transform: uppercase;
            line-height: 30px;
        }
      }
     
      .MenuList li {
          border-top: solid 1px #FFF;
          display: block;
          width: 100%;
          line-height: 60px;
          padding: 0 5px 0 18px;
          font-size: 16px;
          background: #f6f6f6;
          color: #333;
          font-weight: 500;
          text-align: left;
          cursor:pointer;
      }
      .MenuList li:hover {
          color: #fff;
          background: @mainBg;
      }
      .MenuList li.on {
            background: @mainBg;
            color: #fff;
      }
    }
    .Location002308{
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: #e5e5e5 1px solid;
      >div:nth-child(1){
      
        font-weight: bold;
        font-size: 24px;
        color: @main-color;
      }
      >div:nth-child(2){
        font-style: normal;
        color: #999;
        background: url(https://www.yzhospital.cn/cn//images/Location002308-icon.png) no-repeat left center;
        padding-left: 15px;
        >a,>span:nth-child(2){
          position: relative;
          padding-right: 15px;
          margin-right: 10px;
          color: #999;
        }
        >a:hover,>span:nth-child(2):hover{
          color: @main-color;
          cursor: pointer;
        }
        
       
        >a::before,>span:nth-child(2)::before {
            position: absolute;
            content: '';
            right: 0;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid #a1a1a1;
            top: 50%;
            margin-top: -4px;
        }
        >span:nth-child(3){
          color:@main-color;
        }
      }
    }
    @media (max-width: 1280px){
      .auto{
        width: 100%;
        padding: 3% 2% 2%;
       
      }
    }
    @media (max-width: 1024px){
      .auto{
       
        .fl, .fr {
          float: none !important;
        }
        .w22, .w75 {
            width: auto;
            padding-bottom: 2%;
        }
      }
      .Menu000288 .menu {
          display: none;
      }
      
      .Menu000288 .MenuList ul {
          text-align: center;
          padding-bottom: 2%;
          li {
              display: inline-block;
              margin-right: 5px;
              margin-bottom: 5px;
             
          }
          
          li.on {
              padding: 0 10px;
          }
          li {
              display: inline-block;
              width: auto;
              padding: 0 10px 0 10px;
              line-height: 30px;
          }
      }
      
    }
    @media (max-width: 640px){
      .Location002308>div:nth-child(2){
          display: none;
      }
    } 

  </style>
  